import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import {
  ROW_COUNT,
  API_ADMIN_CONTRATISTA_SUBCONTRATISTA,
  URL_SUPPORT,
} from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
interface IContratistaSubContratistaProps {
  items?: Array<any>;
}

const ContratistaSubContratista = ({items}:IContratistaSubContratistaProps) => {
  const userInfo = cognitoUserToken();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  usePromiseEffect(async () => {
      setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" }
    let result = items!==undefined?{data:items,pages:10}:(
      await getAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/getall`,
        { Authorization: `Bearer ${token}` }, params)
    ).result;
    let list = result.data;
    console.log(list);
    setListItems(list);
    let pages = result.pages
    setPages(pages);
    console.log(list);
    setListItems(list);
    setIsLoading(false);
    }, [token]);

  const paging = (page: any) => {
    console.log(page);
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  }

  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    console.log(filter);
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }    
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/getall`, { Authorization: `Bearer ${token}` }, filter).then(result => {
      setIsLoading(false);
      setListItems(result.result.data);
      let pages = result.result.pages
      setPages(pages);
    }).catch(error => {

    });
  }
  const edit = (value: any, filters: any) => {
    console.log(value);

    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;

    value.ID_MAESTRO = value.ID_MAESTRO != undefined ? value.ID_MAESTRO : "";
    value.USUARIO_BACKUP = value.USUARIO_BACKUP != undefined ? value.USUARIO_BACKUP : "";
    value.USUARIO_BACKUP_DISPLAY = value.USUARIO_BACKUP_DISPLAY != undefined ? value.USUARIO_BACKUP_DISPLAY : "";

    postAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}`, value, { Authorization: `Bearer ${token}` }).then(result => {
      let data = result.result.data;
      console.log(data);
      filter(filters, value?.ID > 0);
    }).catch(error => {
      console.log(error);
    });
  }

  const combo =
    [{
      type: "ID_TIPO_CAUSA", value: [
        { text: "...", value: 0 },
        { text: "Actos Sub Estándares", value: 1 },
        { text: "Condiciones Sub Estándares", value: 2 }
      ]
    }];
  return (
    <>
    <button data-testid="btnedit" hidden={true} onClick={() => {
   edit({ ACTIVO: true, AUTOR: "", AUTOR_DISPLAY: "", EDITOR: "", EDITOR_DISPLAY: "", ID_FACTORES: "", ID_TIPO_FACTOR: 1, ORDENADOPOR: "", ORIENTACION: "", PAGINA: 1, PAGINADO: 10, TIPO_FACTOR: "", TITULO: "" }, {});
   paging(1);
 }}></button>
    <AdminLista reload={filter} filter={filter} pagination={{ pages: pages, page: page, paging: paging }}
      items={combo} callback={edit} data={listItems} tipo={"ContratistaSubContratista"} title="Contratistas subcontratistas"
      callbackUpdatePageSize={(pageSize: number, filters: Object)=>{
        setPageSize(pageSize);
        filter(filters, false, pageSize);
      }}
      isLoading={isLoading}/> </>
  );
}

export default ContratistaSubContratista;